module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Design/Layers-db7cc0c913878b9dbec93173eb53378c.svg";